<!-- CC: layout taken from login.component.html -->
<div class="home static-color bs-enabled top-level-page"
	 style="background-image: url('images/loginPageBg.jpg'); width: 100vw; height: 100vh;">
	<div id="wrapper" class="flxClmn centralize" style="min-height: clamp(603px, 88vh, 2500px);">
		<div class="flex-column bg-white p-5 pt-3 login-box" style="width: 425px; min-height: 600px;">
			<div class="align-self-center d-flex centralize p-2" style="flex-basis: 95px; flex-shrink: 0;">
				<img [src]="logo" style="max-height: 45px;" alt="{{corpname}}"
					 [ngStyle]="logo === dic.CONSTANTS.trustifiDefault.logo.svg && {'width': '180px'}">
			</div>

			<div class="flex-column f-1-0 w-100 centralize gap-3 animated fadeIn" *ngIf="loading">
				<i class="far fa-spinner fa-spin text-muted" style="font-size: 1.5rem;"></i>
			</div>

			<div class="flex-column f-1-0 w-100 gap-3 animated fadeIn" *ngIf="!loading && authorizationRequest">
				<span class="fw-500" style="font-size: 1.1rem;">
					Connect <b>{{authorizationRequest.client_name}}</b> to {{corpname}}
				</span>
				<span class="text-muted" *ngIf="authorizationRequest.client_id_host">
					Published by {{authorizationRequest.client_id_host}}
				</span>

				<div class="flex-column gap-2">
					<span>{{authorizationRequest.client_name}} will be able to:</span>
					<div class="flex-row align-items-start gap-2" *ngFor="let scope of authorizationRequest.scopes">
						<i class="far fa-check position-relative text-success" style="font-size: 0.7rem; top: 4px;"></i>
						<span>{{scope.description}}</span>
					</div>
				</div>

				<span class="text-muted">
					Access is granted as <b>{{userEmail}}</b>.
					<a class="no-underline blue-link" (click)="switchAccount()">Use a different account</a>
				</span>
				<span class="text-muted">
					After you allow access you will be redirected to <b>{{authorizationRequest.redirect_host}}</b>
				</span>
				<div class="flex-row align-items-start gap-2 text-danger" *ngIf="authorizationRequest.is_loopback_redirect">
					<i class="far fa-exclamation-triangle position-relative" style="top: 3px;"></i>
					<span>This app runs on your own computer. Allow it only if you started this connection yourself.</span>
				</div>

				<div class="flex-row gap-3 w-100 mt-2">
					<btn-c class="f-1-0" variant="outlined"
						   [isDisabled]="!!decision"
						   [loading]="decision === 'deny'"
						   (action)="decide('deny');">
						Deny
					</btn-c>
					<btn-c class="f-1-0"
						   [isDisabled]="!!decision"
						   [loading]="decision === 'allow'"
						   (action)="decide('allow');">
						Allow
					</btn-c>
				</div>
			</div>

			<div class="text-danger text-start animated fadeIn w-100 mt-3" *ngIf="error">
				{{error}}
			</div>
		</div>
	</div>
</div>
